"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcBDSNeo3 = void 0;
const neon_core_1 = require("@cityofzion/neon-core");
const neon_dappkit_1 = require("@cityofzion/neon-dappkit");
const BSNeo3Helper_1 = require("../../helpers/BSNeo3Helper");
class RpcBDSNeo3 {
    constructor(network, feeToken, claimToken, tokens) {
        this._tokenCache = new Map();
        this._tokens = [];
        this.maxTimeToConfirmTransactionInMs = 1000 * 60 * 2;
        this._network = network;
        this._feeToken = feeToken;
        this._claimToken = claimToken;
        this._tokens = tokens;
    }
    getTransaction(hash) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
                const response = yield rpcClient.getRawTransaction(hash, true);
                return {
                    hash: response.hash,
                    block: response.validuntilblock,
                    fee: neon_core_1.u.BigInteger.fromNumber((_a = response.netfee) !== null && _a !== void 0 ? _a : 0)
                        .add(neon_core_1.u.BigInteger.fromNumber((_b = response.sysfee) !== null && _b !== void 0 ? _b : 0))
                        .toDecimal(this._feeToken.decimals),
                    notifications: [],
                    transfers: [],
                    time: response.blocktime,
                };
            }
            catch (_c) {
                throw new Error(`Transaction not found: ${hash}`);
            }
        });
    }
    getTransactionsByAddress(_params) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Method not supported.');
        });
    }
    getContract(contractHash) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
                const contractState = yield rpcClient.getContractState(contractHash);
                const methods = contractState.manifest.abi.methods.map(method => ({
                    name: method.name,
                    parameters: method.parameters.map(parameter => ({
                        name: parameter.name,
                        type: parameter.type,
                    })),
                }));
                return {
                    hash: contractState.hash,
                    name: contractState.manifest.name,
                    methods,
                };
            }
            catch (_a) {
                throw new Error(`Contract not found: ${contractHash}`);
            }
        });
    }
    getTokenInfo(tokenHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const localToken = this._tokens.find(token => BSNeo3Helper_1.BSNeo3Helper.normalizeHash(token.hash) === BSNeo3Helper_1.BSNeo3Helper.normalizeHash(tokenHash));
            if (localToken)
                return localToken;
            if (this._tokenCache.has(tokenHash)) {
                return this._tokenCache.get(tokenHash);
            }
            try {
                const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
                const contractState = yield rpcClient.getContractState(tokenHash);
                const invoker = yield neon_dappkit_1.NeonInvoker.init({
                    rpcAddress: this._network.url,
                });
                const response = yield invoker.testInvoke({
                    invocations: [
                        {
                            scriptHash: tokenHash,
                            operation: 'decimals',
                            args: [],
                        },
                        { scriptHash: tokenHash, operation: 'symbol', args: [] },
                    ],
                });
                if (!neon_dappkit_1.TypeChecker.isStackTypeInteger(response.stack[0]))
                    throw new Error('Invalid decimals');
                if (!neon_dappkit_1.TypeChecker.isStackTypeByteString(response.stack[1]))
                    throw new Error('Invalid symbol');
                const decimals = Number(response.stack[0].value);
                const symbol = neon_core_1.u.base642utf8(response.stack[1].value);
                const token = {
                    name: contractState.manifest.name,
                    symbol,
                    hash: contractState.hash,
                    decimals,
                };
                this._tokenCache.set(tokenHash, token);
                return token;
            }
            catch (_a) {
                throw new Error(`Token not found: ${tokenHash}`);
            }
        });
    }
    getBalance(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
            const response = yield rpcClient.getNep17Balances(address);
            const promises = response.balance.map((balance) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                let token = {
                    hash: balance.assethash,
                    name: '-',
                    symbol: '-',
                    decimals: 8,
                };
                try {
                    token = yield this.getTokenInfo(balance.assethash);
                }
                catch (_b) {
                    // Empty Block
                }
                return {
                    amount: neon_core_1.u.BigInteger.fromNumber(balance.amount).toDecimal((_a = token === null || token === void 0 ? void 0 : token.decimals) !== null && _a !== void 0 ? _a : 8),
                    token,
                };
            }));
            const balances = yield Promise.all(promises);
            return balances;
        });
    }
    getBlockHeight() {
        return __awaiter(this, void 0, void 0, function* () {
            const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
            return yield rpcClient.getBlockCount();
        });
    }
    getUnclaimed(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const rpcClient = new neon_core_1.rpc.RPCClient(this._network.url);
            const response = yield rpcClient.getUnclaimedGas(address);
            return neon_core_1.u.BigInteger.fromNumber(response).toDecimal(this._claimToken.decimals);
        });
    }
    getRpcList() {
        return __awaiter(this, void 0, void 0, function* () {
            const list = [];
            const urls = BSNeo3Helper_1.BSNeo3Helper.getRpcList(this._network);
            const promises = urls.map(url => {
                // eslint-disable-next-line no-async-promise-executor
                return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                    const timeout = setTimeout(() => {
                        resolve();
                    }, 5000);
                    try {
                        const rpcClient = new neon_core_1.rpc.RPCClient(url);
                        const timeStart = Date.now();
                        const height = yield rpcClient.getBlockCount();
                        const latency = Date.now() - timeStart;
                        list.push({ url, latency, height });
                    }
                    finally {
                        resolve();
                        clearTimeout(timeout);
                    }
                }));
            });
            yield Promise.allSettled(promises);
            return list;
        });
    }
}
exports.RpcBDSNeo3 = RpcBDSNeo3;
